import React, {Component} from "react";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";
import SimpleModal from "../../../modules/popup/SimpleModal";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";

class ClaimC1Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    componentDidMount = async () => {
    }

    handleValueChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleDateValueChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                claimDate: {
                    ...prevValue.filterData.claimDate,
                    [name]: value
                }
            }
        }))
    }

    handleReset = () => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            filterData: {
                claimDate: {
                    tanggalAkhir: null,
                    tanggalAwal: null
                },
                claimStatus: null,
            },
        }));
    };

    handleSubmit = () => {
        this.props.onSubmit();
    };

    render() {
        return (
            <>
                <SimpleModal
                    title="Filter Search"
                    visible={this.props.state.filterVisible}
                    onClickClose={this.props.onClickClose}
                    content={
                        <ModalContainer>
                            <SimpleInput
                                id="input_text_claim_no"
                                name="claimNo"
                                label="No Claim"
                                value={this.props.state.filterData.claimNo}
                                onChange={({target}) =>
                                    this.handleValueChange(target.name, target.value)}
                            />
                            <FlexView column vAlignContent="center">
                                <p>Tanggal Claim</p>
                                <FlexView vAlignContent="center" style={{gap: "10px"}}>
                                    <SimpleDate
                                        name="tanggalAwal"
                                        date={this.props.state.filterData.claimDate.tanggalAwal}
                                        onChange={(value) =>
                                            this.handleDateValueChange("tanggalAwal", M(value).format("DD-MM-YYYY"))}
                                    />
                                    <span className="margin-bottom-20px">s/d</span>
                                    <SimpleDate
                                        name="tanggalAkhir"
                                        date={this.props.state.filterData.claimDate.tanggalAkhir}
                                        onChange={(value) =>
                                            this.handleDateValueChange("tanggalAkhir", M(value).format("DD-MM-YYYY"))}
                                    />
                                </FlexView>
                            </FlexView>
                            <SimpleDDL
                                id="select_options_kode_locator"
                                box="search"
                                name="kodeLocator"
                                label="Lokasi"
                                isClearable
                                options={this.props.state.options.locatorOptions}
                                value={
                                    !R.isNil(this.props.state.filterData.kodeLocator) ?
                                        this.props.state.filterData.kodeLocator : null
                                }
                                onChange={(value, {name}) =>
                                    this.handleValueChange(name, value)
                                }
                            />
                            <SimpleInput
                                id="input_text_engine_number"
                                name="engineNumber"
                                label="NoSin"
                                value={this.props.state.filterData.engineNumber}
                                onChange={({target}) =>
                                    this.handleValueChange(target.name, target.value)}
                            />
                            <SimpleInput
                                id="input_text_frame_number"
                                name="frameNumber"
                                label="NoKa "
                                value={this.props.state.filterData.frameNumber}
                                onChange={({target}) =>
                                    this.handleValueChange(target.name, target.value)}
                            />
                            <SimpleDDL
                                id="select_options_claim_status"
                                box="search"
                                name="claimStatus"
                                label="Status"
                                options={this.props.state.options.statusOptions}
                                value={this.props.state.filterData.claimStatus}
                                onChange={(value, {name}) =>
                                    this.handleValueChange(name, value)
                                }
                            />
                            <FlexView hAlignContent="right">
                                <SimpleButton
                                    type="button"
                                    secondary
                                    onClick={this.handleReset}
                                >
                                    Reset
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>
                        </ModalContainer>
                    }
                />
            </>
        )
    }
}

export default ClaimC1Filter;